import React from 'react';
import './SiteFooter.css';

const PORTFOLIO_URL = 'https://aminajaved.com/';

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <p className="site-footer__text">
          <span>&copy; {year} GiftLink</span>
          <span className="site-footer__sep" aria-hidden="true">&middot;</span>
          <span>
            Built by{' '}
            <a
              href={PORTFOLIO_URL}
              target="_blank"
              rel="noopener noreferrer author"
              className="site-footer__link"
            >
              Amina Javed
            </a>
          </span>
          <span className="site-footer__sep" aria-hidden="true">&middot;</span>
          <span>All rights reserved</span>
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;
